import kvItem from './src/main'
kvItem.install = function (Vue) {
  Vue.component(kvItem.name, kvItem)
}
export default kvItem



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/kvItem/index.js